import { observer } from "mobx-react-lite";
import { Button, Icon, Header, Label, Segment } from "semantic-ui-react";

import { Form, Formik, Field, useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import ReactToPrint from "react-to-print";
import React, { useEffect, useState, useRef } from "react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import MyTextInput, { MyTextInputConvD, MyTextInputConv, MyTextAreatConv, MyTextInputFechas } from "../../../app/common/form/MyTextInput";
import aproveanim from '../../PerfilInstitucional/src/lotties/aprobacion.json';
import { calculoFechas } from "../../Portafolio/helpers/calculoFechas";
import Container from 'react-bootstrap/Container';
import Lottie from "react-lottie";
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import "../src/css/convenios.css";

const aprovePathURL = process.env.REACT_APP_API_URL + "/CATConvenios/ChangeStatus";

const defaultOptions = {
  loop: true,
  autoplay: true,
  isClickToPauseDisabled: true,
  animationData: aproveanim,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid"
  }
};

export default observer(function ModalAproveConv(

  SOL: {
    show: any,
    onHide: any,
    id: any,
    idConvenio: any,
    Files: any,
    correlativo: string,
    cnombre: string
  }) {

  const id = SOL.id;
  const idConvenio = SOL.idConvenio;
  const files = SOL.Files;
  // console.log("data", id, idConvenio, files);

  const handleAprove = async () => {

    const formData = new FormData();
    formData.append('Id', id.toString());
    formData.append('IdConvenio', idConvenio.toString());
    formData.append('Files', files)

    try {
      const response = await fetch(aprovePathURL, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        ExitMsj();
        // La solicitud fue exitosa
        // console.log('La información fue enviada correctamente al API y el convenio fue aprobado');
      } else {
        ExitMsjError()
        // Hubo un error en la solicitud
        // console.error('Hubo un error al enviar la información al API.');
      }
    } catch (error) {
      // console.error('Hubo un error en la solicitud:', error);
    }
  };

  function ExitMsj() {
    // Swal.fire({
      // position: "center",
      // icon: "success",
      // title: "Convenio Aprobado",
      // text: 'El convenio ha sido aprobado satisfactoriamente.',
      // showConfirmButton: false,
      // timer: 3500,
    // });
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Código Aprobado",
      text: 'El código institucional ha sido aprobado satisfactoriamente.',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      willClose: () => {
        // window.location.reload();
      }
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        // window.location.reload();
      }
    })
  };

  function ExitMsjError() {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "Error",
      text: 'Ha ocurrido un error en la actualización, por favor verifica que la informacion sea correcta e intenta de nuevo.',
      showConfirmButton: false,
      timer: 3500,
    });
  };

  return (

    <>

      <Modal
        {...SOL}
        size="lg"
        className="modal-add-dep-content"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >

        <Modal.Header closeButton >
          <Modal.Title id="contained-modal-title-vcenter">
            Aprobación del código institucional: {SOL.correlativo}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container className="modal-sol-detalle modal-aprove">

            <Container className="aprove-alert">
              <p>Te encuentras a punto de aprobar el código institucional y debes tomar en cuenta que una vez este haya sido aprobado no lo podrás modificar y este quedara listo para que los estudiantes puedan inscribirse al servicio académico relacionado a este convenio. <br/> <span>{SOL.cnombre}</span></p>
            </Container>

            <Container className="anim-area lootie-area">
              <Lottie
                isClickToPauseDisabled={true}
                options={defaultOptions}
              />
            </Container>

            <p className="question">¿Estás seguro de aprobar el código?</p>

            <Container className="buttons-footer-area">
              <Button
                className="green upload-files"
                type="button"
                animated
                onClick={handleAprove}
              >
                <Button.Content visible>
                  Aprobar Código
                </Button.Content>
                <Button.Content hidden>
                  <Icon name="file pdf outline" />
                </Button.Content>
              </Button>
            </Container>

          </Container>
        </Modal.Body>

      </Modal>

    </>

  );

})
